import React, { useState, useEffect, useMemo } from "react";
import Header from "../component/Header";
import ExploreResultLocations from "../component/ExploreResultLocations";
import Footer from "../component/Footer";
import ConnectAgentCTA from "../component/ConnectAgentCTA";
import CommonBanner from "../component/CommonBanner";
import { Col, Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import BlogImg1 from "../assets/images/blog-1.png";
import BlogImg2 from "../assets/images/blog-2.png";
import BlogImg3 from "../assets/images/blog-3.png";
import BlogImg4 from "../assets/images/blog-4.png";
import BlogImg5 from "../assets/images/blog-5.png";
import BlogImg6 from "../assets/images/blog-6.png";
import BlogImg7 from "../assets/images/blog-7.png";
import BlogImg8 from "../assets/images/blog-8.png";
import BlogImg9 from "../assets/images/blog-9.png";
import { Link } from "react-router-dom";
import { useNewsList } from "../hooks/useNewsList";
import { usePageContent } from "../hooks/usePageContent";
import { Helmet } from "react-helmet-async";

function NewsEvents() {
  const { news, loading, error } = useNewsList();
  const { content } = usePageContent("news-events");

  // Parse news_events_section data
  const newsEventsSectionData = useMemo(() => {
    if (!content?.news_events_section) return null;
    try {
      return JSON.parse(content.news_events_section);
    } catch (error) {
      console.error("Error parsing news_events_section:", error);
      return null;
    }
  }, [content]);

  // Default values
  const bannerTitle = content?.page_name || "News & Events";
  const bannerImage = content?.main_banner_image;

  return (
    <>
      <Helmet>
        <title>{`${bannerTitle} | Jambobay`}</title>
        <meta
          name="description"
          content="Explore the latest news, updates, and events from Jambobay."
        />
        <meta
          name="keywords"
          content="News, Events, Jambobay, Real Estate Updates, Announcements"
        />
      </Helmet>
      <div className="main blog-page">
        <Header />
        <CommonBanner 
          title={bannerTitle}
          bannerImage={bannerImage}
        />
        <div className="blog-list common-padding">
          <Container>
          <div className="common-header">
                <h2 className="mb-0" dangerouslySetInnerHTML={{ 
                  __html: newsEventsSectionData?.section_1?.title || "News<span>&</span>Events"
                }} />
            </div>
              <Row className="row-gap-4">
                         {loading && <p>Loading news and events...</p>}
                         {error && <p className="text-danger">{error}</p>}
                         {!loading && !error && news.length === 0 && <p>No news found</p>}
                         {!loading && news.map((blog) => (
                           <Col lg={4} md={6} sm={12} key={blog.id}>
                             <Link to={`/news-details/${blog.slug || blog.id}`} className="blog-item">
                               <div className="blog-image">
                                 <img 
                                   src={blog.image}
                                   alt={blog.title} 
                                 />
                               </div>
                               <div className="blog-content">
                                 <p>{blog.category_name}</p>
                                 <h3>{blog.title}</h3>
                               </div>
                             </Link>
                           </Col>
                         ))}
                       </Row>
          </Container>
        </div>
        <ConnectAgentCTA section={newsEventsSectionData?.section_2} />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}

export default NewsEvents;
